import { useApi } from "../composables/useApi";
export const useHRApi = useApi((args) => ({
  ...(args || {}),
  baseURL: "https://api.hypereveal.com",
}));
